import { Form, Select, Spin } from 'antd';
import React, { useState } from 'react';
import Button from '../../../components/Button/Button';
import FormItem, { FileFormItem } from '../../../components/FormItem/FormItem';
import DatePicker from '../../../components/DatePicker/DatePicker';
import Input from '../../../components/Input/Input';
import { useNavigate  } from 'react-router-dom';

import styles from './RegisterDetails.module.scss';
import { updateUser, validateNick } from '../../../service/user';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';
import { uploadUserImage } from '../../../service/files';
import { useUserStore } from '../../../store/useUser';
import { useQuery } from 'react-query';
import { createUserGenres, getAllGenres } from '../../../service/genres';

import moment from 'moment';
import ImageInput from '../../../components/ImageInput/ImageInput';
import useHeader from '../../../hooks/useHeader';

const { Option } = Select;

const RegisterDetails: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();

  const userId = useUserStore(state => state.id)

  useHeader({ header: 'Cadastro' });

  const {data: genres, isFetching} = useQuery(
    ['genres'],
    () => getAllGenres(),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const onFinish = async (): Promise<void> => {
    if(loading) return

    setLoading(true)

    const payload = form.getFieldsValue();

    const format = 'YYYY-MM-DD HH:mm'

    if (payload.birthdate) {
      payload.birthdate = moment(payload.birthdate).format(format)
    }
    
    if(payload.genres) { 
      const {error, success} = await createUserGenres(userId, payload.genres)
    }

    delete payload.genres

    const {error, success} = await updateUser(userId, payload)
    
    if(error){
      setLoading(false)

      return createErrorNotification(error)
    }

    if(payload.file){
      const {error: errorFile, success} = await uploadUserImage(userId, payload.file)
      if(errorFile)
        createErrorNotification(errorFile)
    }
    
    setLoading(false)

    createSuccessNotification('Usuário atualizado!')

    navigate(`/user/${userId}`)
  }

    function onSelectImage(file: File) {
      form.setFields([
        {name: 'file', value: file},
      ]);
  
      form.validateFields(['file']);
    }

    return(
        <div className={styles.container}>
          <div className={styles.maskContainer}></div>
            <div className={styles.createContainer}>
              <div className={styles.createForm}>
                <Form 
                  form={form} 
                  layout="vertical" 
                  onFinish={onFinish} 
                  hideRequiredMark 
                  id="formLogin" 
                  className={styles.FormContainer}
                >
                  <h2 className={styles.title}>Seja bem-vindo(a)</h2>
                  <FormItem
                    label="Nome de usuário"
                    name="nick"
                    rules={[
                      {
                        required: true,
                      },
                      {
                        validateTrigger: 'onBlur',
                        validator: async (_, value) => {
                          if (!value) return

                          setLoading(true)

                          const testNick = /^[A-Za-z0-9_]+$/.test(value);

                          if (!testNick) {
                            return Promise.reject(new Error('Por favor, insira um nick válido! Apenas letras, números e _'));
                          }

                          const {error, success} = await validateNick(userId, value)
                          
                          setLoading(false)

                          if(error) return Promise.reject(new Error('Nick já está em uso'));
                        }
                      },
                    ]}
                    >
                      <Input />
                  </FormItem>
                  <FormItem
                    label="Data de Nascimento"
                    name="birthdate"
                    rules={[
                      {
                        required: true,
                        message: "Por favor, insira uma data de aniver"
                      }
                    ]}
                  >
                    <DatePicker 
                      onChange={(value, string) => {
                        return string
                      }}
                    />
                  </FormItem>
                  <FormItem
                    label="Gêneros Literários Favoritos"
                    name="genres">
                    <Select
                      mode="multiple">
                      { 
                        genres?.map(genre => {
                          return <Option value={genre.id}>{genre.content}</Option>
                        })
                      }
                    </Select>
                  </FormItem>
                  <FormItem
                    label="Cidade"
                    name="city"
                  >
                    <Input />
                  </FormItem>
                  <FileFormItem
                    name="file"
                    label="Foto de perfil"
                    >
                    <ImageInput 
                      accept='image/*'
                      title="Arraste e solte sua foto de perfil"
                      onChangeFile={onSelectImage}
                    />
                  </FileFormItem>
                    <Button loading={loading} submit style={styles.button}>Concluir cadastro!</Button>
                    <Button onClick={()=> navigate(`/user/${userId}`)} style={styles.button}>Ou deixe pra depois</Button>
                  </Form>
                </div>
            </div>
        </div>
      )
}

export default RegisterDetails;